export const GET_POSITION_LIST = 'GET_POSITION_LIST';

export const REACHED_SUMMARY = 'REACHED_SUMMARY';
